import React from "react";
import { Flex, Text, Box } from "@chakra-ui/react";
import Balancer from "react-wrap-balancer";
import { Section } from "components/section";
import { HeroVideo } from "components/half-hero-animation";
import { BookDemoButton } from "./event-tracking";

export function Customer360Hero({
  eyebrow,
  title,
  description,
}: {
  eyebrow: string;
  title: string;
  description: string;
}) {
  return (
    <Section pos="relative" my={{ base: 12, md: 16 }}>
      <Flex
        align={{ base: "center", lg: "start" }}
        justify={{ base: "center", lg: "space-between" }}
        direction={{ base: "column", lg: "row" }}
        gap={{ base: 8, lg: 12, xl: 24 }}
        maxW={{ base: "2xl", md: "3xl", lg: "100%" }}
        mx="auto"
      >
        <Box flex={1} textAlign={{ base: "center", lg: "left" }}>
          <Text textStyle="uppercase" mb={4}>
            {eyebrow}
          </Text>

          <Text as="h1" textStyle="h3">
            <Balancer>{title}</Balancer>
          </Text>

          <Text as="h2" fontSize="lg" mt={8} mb={12} maxW={{ base: "60ch", lg: "100%" }} mx="auto">
            {description}
          </Text>

          <Flex justify={{ base: "center", lg: "start" }}>
            <BookDemoButton />
          </Flex>
        </Box>

        <Flex flex={1.25} w="100%" justify="center" mt={{ base: 0, lg: -8 }}>
          <HeroVideo
            title="Hightouch Customer 360 Toolkit"
            description={description}
            uploadDate="2023-07-09T08:00:00+08:00"
            poster="https://cdn.sanity.io/images/pwmfmi47/production/7ed28194562cb4ab77217ef708511b5ed07606dc-1830x1408.webp"
            sourceWebm="https://cdn.sanity.io/files/pwmfmi47/production/57f375779050fe57537cbe99719124aec63cebfa.webm"
            sourceMp4="https://cdn.sanity.io/files/pwmfmi47/production/251bfa75a6be534e4235dbc1cc7ac3407b12081b.mp4"
          />
        </Flex>
      </Flex>
    </Section>
  );
}
